"use client";

import Loader from "./Loader";

type ModalLoadingOverlayProps = {
  message?: string;
};

export default function ModalLoadingOverlay({
  message = "Please wait while we process your request...",
}: ModalLoadingOverlayProps) {
  return (
    <div className="absolute inset-0 z-20 flex items-center justify-center bg-white/90 px-6 backdrop-blur-sm">
      <div className="flex max-w-xs flex-col items-center text-center">
        <Loader />
        <p className="mt-4 text-sm font-medium text-slate-600">{message}</p>
      </div>
    </div>
  );
}
